import { observer } from 'mobx-react-lite'
import { ViewAcceptedTermsDialog } from './'
import { type ViewAcceptedTermsDialogViewModel } from './ViewAcceptedTermsDialogViewModel'

interface ViewAcceptedTermsDialogContainerProps {
  vm: ViewAcceptedTermsDialogViewModel
}

/**
 * Container component for viewing accepted terms dialog
 */
export const ViewAcceptedTermsDialogContainer = observer(
  function ViewAcceptedTermsDialogContainer({
    vm,
  }: ViewAcceptedTermsDialogContainerProps) {
    return (
      <ViewAcceptedTermsDialog
        isOpen={vm.modal.showing}
        termsMarkup={vm.terms.markup}
        onClose={vm.modal.close}
      />
    )
  },
)
